import axios from "axios";
import * as actions from "./actionsTypes";
import messages from "../../messages";
import toastr from "toastr";
import TrainingServices from "./Training.services";
import GeneralInfoServices from "../GeneralInfo/GeneralInfo.services";

toastr.options = {
  closeButton: false,
  debug: false,
  newestOnTop: false,
  progressBar: true,
  positionClass: "toast-top-right",
  preventDuplicates: false,
  onclick: null,
  showDuration: "300",
  hideDuration: "1000",
  timeOut: "5000",
  extendedTimeOut: "1000",
  showEasing: "swing",
  hideEasing: "linear",
  showMethod: "fadeIn",
  hideMethod: "fadeOut",
};

export const getTraining = (filters) => async (dispatch) => {
  try {
    dispatch({
      type: actions.LOADING_TRAINING,
      payload: true,
    });
    const resp = await TrainingServices.getTraining(filters);
    dispatch({
      type: actions.GET_TRAINING,
      payload: {
        trainings: resp.data.data,
        trainingsLength: resp.data.count,
      },
    });
    dispatch({
      type: actions.TRAINING_FAIL,
      payload: "",
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 404:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
    dispatch({
      type: actions.TRAINING_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.LOADING_TRAINING,
      payload: false,
    });
  }
};

export const resetGeneralInfo = () => async (dispatch) => {
  try {
    dispatch({
      type: actions.LOADING_TRAINING,
      payload: true,
    });
    dispatch({
      type: actions.GET_TRAINING,
      payload: {
        trainings: [],
        trainingsLength: 0,
      },
    });
    dispatch({
      type: actions.TRAINING_FAIL,
      payload: "",
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 404:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
    dispatch({
      type: actions.TRAINING_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.LOADING_TRAINING,
      payload: false,
    });
  }
};

export const getTrainingById = (id) => async (dispatch) => {
  try {
    dispatch({
      type: actions.LOADING_TRAINING_BY_ID,
      payload: true,
    });
    const resp = await TrainingServices.getTrainingById(id);
    dispatch({
      type: actions.GET_TRAINING_BY_ID,
      payload: resp.data,
    });
    dispatch({
      type: actions.TRAINING_FAIL,
      payload: "",
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 404:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
    dispatch({
      type: actions.TRAINING_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.LOADING_TRAINING_BY_ID,
      payload: false,
    });
  }
};

export const saveTraining = (data, setShowModal) => async (dispatch, getState) => {
    try {
      dispatch({
        type: actions.SAVE_LOADING_TRAINING,
        payload: true,
      });
      const resp = await TrainingServices.saveTraining(data);
      const { trainings, trainingsLength } = getState().training;
      const _training = [...trainings, resp.data];
      dispatch({
        type: actions.GET_TRAINING,
        payload: {
          trainings: _training,
          trainingsLength: trainingsLength + 1,
        },
      });
      dispatch({
        type: actions.FORM_FAIL_TRAINING,
        payload: "",
      });
      setShowModal(false);
      toastr.success(messages.successMessage, "", {
        progressBar: true,
        rtl: true,
      });
    } catch (ex) {
      let message = null;
      if (axios.isAxiosError(ex)) {
        if (ex.response?.status) {
          switch (ex.response.status) {
            case 400:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            case 404:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            case 500:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            default:
              message = ex.response.data;
              break;
          }
        } else {
          message =
            ex.message === "Network Error" ? messages.networkError : ex.message;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
      dispatch({
        type: actions.FORM_FAIL_TRAINING,
        payload: message,
      });
    } finally {
      dispatch({
        type: actions.SAVE_LOADING_TRAINING,
        payload: false,
      });
    }
  };

export const editTraining = (data, id, index, setShowModal) => async (dispatch, getState) => {
    try {
      dispatch({
        type: actions.LOADING_TRAINING,
        payload: true,
      });
      const resp = await TrainingServices.editTraining(id, data);
      const { trainings, trainingsLength } = getState().training;
      const dataT = resp.data
      trainings[index] = dataT;
      dispatch({
        type: actions.GET_TRAINING,
        payload: {
          trainings: trainings,
          trainingsLength: trainingsLength,
        },
      });
      dispatch({
        type: actions.FORM_FAIL_TRAINING,
        payload: "",
      });
      setShowModal(false);
      toastr.success(messages.successMessage, "", {
        progressBar: true,
        rtl: true,
      });
      const _data = {
        data:[
          {
            funcion_descriptor:dataT.list_descriptor[0].posicion,
            tipo_mensaje:"Jefe actualiza descriptor"
          }
        ]
      }
      await GeneralInfoServices.mailSendGeneralInfo(_data);
      toastr.success(messages.correoEnviado, '', {
        progressBar: true,
        rtl: true,
      });
    } catch (ex) {
      let message = null;
      if (axios.isAxiosError(ex)) {
        if (ex.response?.status) {
          switch (ex.response.status) {
            case 400:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            case 404:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            case 500:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            default:
              message = ex.response.data;
              break;
          }
        } else {
          message =
            ex.message === "Network Error" ? messages.networkError : ex.message;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
      dispatch({
        type: actions.FORM_FAIL_TRAINING,
        payload: message,
      });
    } finally {
      dispatch({
        type: actions.LOADING_TRAINING,
        payload: false,
      });
    }
  };

export const editIndispensable = (data, id, index) => async (dispatch, getState) => {
    try {
      // dispatch({
      //   type: actions.LOADING_TRAINING,
      //   payload: true,
      // });
      const resp = await TrainingServices.editTraining(id, data);
      const dataT = resp.data
      // const { trainings, trainingsLength } = getState().training;
      // trainings[index] = resp.data;
      // dispatch({
      //   type: actions.GET_TRAINING,
      //   payload: {
      //     trainings: trainings,
      //     trainingsLength: trainingsLength,
      //   },
      // });
      // dispatch({
      //   type: actions.FORM_FAIL_TRAINING,
      //   payload: "",
      // });
      toastr.success(messages.successMessage, "", {
        progressBar: true,
        rtl: true,
      });
      const _data = {
        data:[
          {
            funcion_descriptor:dataT.list_descriptor[0].posicion,
            tipo_mensaje:"Jefe actualiza descriptor"
          }
        ]
      }
      await GeneralInfoServices.mailSendGeneralInfo(_data);
      toastr.success(messages.correoEnviado, '', {
        progressBar: true,
        rtl: true,
      });
    } catch (ex) {
      let message = null;
      if (axios.isAxiosError(ex)) {
        if (ex.response?.status) {
          switch (ex.response.status) {
            case 400:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            case 404:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            case 500:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            default:
              message = ex.response.data;
              break;
          }
        } else {
          message =
            ex.message === "Network Error" ? messages.networkError : ex.message;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
      // dispatch({
      //   type: actions.FORM_FAIL_TRAINING,
      //   payload: message,
      // });
    } finally {
      // dispatch({
      //   type: actions.LOADING_TRAINING,
      //   payload: false,
      // });
    }
  };

  export const editTrainingById = (data, id, setValidated) => async (dispatch, getState) => {
    try {
      dispatch({
        type: actions.SAVE_LOADING_TRAINING_BY_ID,
        payload: true,
      });
      const resp = await TrainingServices.editTraining(id, data);
      const dataT = resp.data;
      dispatch({
        type: actions.GET_TRAINING_BY_ID,
        payload: dataT,
      });
      // const { trainings, trainingsLength } = getState().training;
      // trainings[index] = resp.data;
      // dispatch({
      //   type: actions.GET_TRAINING,
      //   payload: {
      //     trainings: trainings,
      //     trainingsLength: trainingsLength,
      //   },
      // });
      setValidated(false)
      dispatch({
        type: actions.FORM_FAIL_TRAINING,
        payload: "",
      });
      toastr.success(messages.successMessage, "", {
        progressBar: true,
        rtl: true,
      });
      const _data = {
        data:[
          {
            funcion_descriptor:dataT.list_descriptor[0].posicion,
            tipo_mensaje:"Jefe actualiza descriptor"
          }
        ]
      }
      await GeneralInfoServices.mailSendGeneralInfo(_data);
      toastr.success(messages.correoEnviado, '', {
        progressBar: true,
        rtl: true,
      });
    } catch (ex) {
      let message = null;
      if (axios.isAxiosError(ex)) {
        if (ex.response?.status) {
          switch (ex.response.status) {
            case 400:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            case 404:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            case 500:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            default:
              message = ex.response.data;
              break;
          }
        } else {
          message =
            ex.message === "Network Error" ? messages.networkError : ex.message;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
      dispatch({
        type: actions.FORM_FAIL_TRAINING,
        payload: message,
      });
    } finally {
      dispatch({
        type: actions.SAVE_LOADING_TRAINING_BY_ID,
        payload: false,
      });
    }
  };

export const deleteTraining = (id, index) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.LOADING_TRAINING,
      payload: true,
    });
    await TrainingServices.deleteTraining(id);
    const { trainings, trainingsLength } = getState().training;
    trainings.splice(index, 1);
    dispatch({
      type: actions.GET_TRAINING,
      payload: {
        trainings: trainings,
        trainingsLength: trainingsLength - 1,
      },
    });
    dispatch({
      type: actions.TRAINING_FAIL,
      payload: "",
    });
    toastr.success(messages.successMessage, "", {
      progressBar: true,
      rtl: true,
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 404:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
    dispatch({
      type: actions.TRAINING_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.LOADING_TRAINING,
      payload: false,
    });
  }
};
